module.exports = __webpack_public_path__ + "media/components/country-flag/static/nu-bfd6de48e40574ec6d86c6e0589baa48.svg";